import { styled } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Modal from 'components/Modal';

const backgroundColor = theme.palette.primary.main;
const textColor = theme.palette.white;

export const StyledModal = styled(Modal)`
  .MuiPaper-root {
    background: ${backgroundColor};

    ${theme.breakpoints.up('sm')} {
      min-height: 560px;
    }
  }
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Header = styled('div')`
  color: ${textColor};
  padding: 4rem 1rem 2rem;
`;
